import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Input } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import * as moment from 'moment';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';

@Component({
  selector: 'app-pro-rata-prices-modal',
  templateUrl: './pro-rata-prices-modal.component.html',
  styleUrls: ['./pro-rata-prices-modal.component.scss'],
})
export class ProRataPricesModalComponent implements OnInit {
  ERROR = '';
  @Input('data') data:any;
  proratedData:any[]=[];
  lang:any='';
  proratadValues:any[]=[];

  constructor(
    private modalController: ModalController,
    private UTS : UtilitiesService,
    private appInitService: ApplicationInitializationService
  ) {
    this.lang = this.UTS.getLocaleLanguage();
  }

  ngOnInit() {
    this.proratedData = this.data || [];
    this.proratadValues= this.appInitService?.environmentConfig?.B2C_PRORATA_TOTAL_VALUE;
  }

 
  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }


  get getCurrentDate(){
    return new Date();
  }

  get lastDate(){
    return new Date(this.getCurrentDate.getFullYear(), this.getCurrentDate.getMonth() + 1, 0);
  }

  get getDays(){
    return this.lastDate.getDate() - this.getCurrentDate.getDate() + 1;
  }

  save(){
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  get getCurrentMonth(){
    if (this.lang == 'ar') {
      moment.locale('ar-kw');
      return moment(Date.now()).format('MMM');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('MMM'); // 13th April, 2020
    }
  }

  checkValue(service:any){
    const data = this.proratadValues.find((x:any)=>service?.totalValue && (service?.totalValue == x?.value));
    return data ? data : '';
   }


}
